/* unplugin-vue-components disabled */import { render } from "./PoolChangeOwnerComponent.vue?vue&type=template&id=2b4f27ca"
import script from "./PoolChangeOwnerComponent.vue?vue&type=script&lang=js"
export * from "./PoolChangeOwnerComponent.vue?vue&type=script&lang=js"

import "./PoolChangeOwnerComponent.vue?vue&type=style&index=0&id=2b4f27ca&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__